import Chart from 'chart.js/auto';

export default {
  fontSize: Chart.defaults.offscreenRendering ? 20 : 12,
  renderingRatio: Chart.defaults.offscreenRenderingRatio || 1,
  fontFamily: 'opensans-semibold',
  fontStyle: '600',
};
